import { Button, Icon, Tooltip, Theme } from '@busybusy/webapp-react-ui';
import * as React from 'react';

export interface IPhotoActionButtonProps {
  tooltip: string;
  svg: any;
  onClick?: () => void;
}

const PhotoActionButton: React.FunctionComponent<IPhotoActionButtonProps> = (props) => {
  const { tooltip, svg, onClick } = props;
  return (
    <Tooltip label={tooltip}>
      <Button type="icon" theme={Theme.DARK} onClick={onClick}>
        <Icon svg={svg} />
      </Button>
    </Tooltip>
  );
};

export default PhotoActionButton;
